import { useContext, useEffect, useState } from "react";
import { Accordion, OverlayTrigger, Tooltip } from "react-bootstrap";
import { extensions, imageFileExtension } from "../../settings/shared/commonMethods";
import { ClipLoader } from "react-spinners";
import emptyFolder from "../../assets/img/icons/empty_folder.png";
import { FileEditContext } from "./FileEditContext";



const TreeView = (props) => {

    const [storageData, setStorageData] = useState("");
    const [parentIndex, setParentIndex] = useState(0);
    const [selectedPath, setSelectedPath] = useState("");

    const { fileContextValue, setFileContextValue } = useContext(FileEditContext);

    useEffect(() => {
        let files = props?.files;
        let folder = props?.folders;
        const data = { root: files, folder };

        data && constructTreeData(data);
    }, [props?.files, props?.folders]);

    const constructTreeData = (data) => {
        const root = {};

        data?.folder && data?.folder?.forEach(folder => {
            const parts = folder?.split("/").filter(Boolean);
            let current = root;
            if (parts) {
                for (const part of parts) {
                    current[part] = current[part] || {};
                    current = current[part];
                }
            }
        });

        data?.root && data?.root?.forEach(file => {
            const parts = file?.name?.split("/").filter(Boolean);
            const fileName = parts.pop();
            let current = root;
            if (parts && parts?.length > 0) {
                for (const part of parts) {
                    current[part] = current[part] || {};
                    current = current[part];
                }
                current[fileName] = file; // attach full file info here
            }
        });
        setStorageData(root);
        setTimeout(() => {
            if (parentIndex === 0) {
                let element = document.getElementById("0");
                let accordionElement = element?.querySelector(".accordion-item");
                accordionElement && accordionElement?.querySelector(".accordion-collapse")?.classList.toggle("show");
                accordionElement && accordionElement?.querySelector(".accordion-header .accordion-button").classList.toggle("collapsed");
            }
        }, 400)
    }

    const onFolderClick = (name, node, fullPath, index) => {
        let load;
        setParentIndex(index);
        setSelectedPath(fullPath);
        props._renderFetchStorageFilesFolders(fullPath, load = false);
    }

    const onFileClick = (name, node, fullPath) => {
        setSelectedPath(fullPath);
        let checkDup = fileContextValue?.filter((item) => item?.name === node?.name);
        if (checkDup?.length === 0) {
            setFileContextValue([...fileContextValue, node]);
        }
    }

    const treeNode = (node, name, path = "", index) => {
        const fullPath = path ? `${path}/${name}` : name;
        const isLeaf = typeof node !== "object" || node.created; // File objects have `created`

        if (isLeaf) {
            return <li className={`action-pointer ${fullPath === selectedPath ? 'selected' : ''}`}
                onClick={() => onFileClick(name, node, fullPath)}>
                <img className="" src={extensions(imageFileExtension(name))} alt=""></img>
                {name}
            </li>;
        }

        return (
            <Accordion id={index}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header className={`${fullPath === selectedPath ? 'selected' : ''}`}
                        onClick={() => onFolderClick(name, node, fullPath)}>
                        <i className="fas fa-folder ps-1 pe-1 sa-folder"></i>{name}
                    </Accordion.Header>
                    <Accordion.Body className="p-0">
                        {props?.loading && fullPath === selectedPath && <div className="tree-node-loader d-flex align-items-center p-2 ps-3">
                            <ClipLoader color="#45bcc7" size={15} /> &nbsp;&nbsp;
                            <span className="d-inline-block">Loading...</span>
                        </div>}
                        <ul style={{ paddingLeft: 12 }}>
                            {Object.entries(node).map(([key, child]) => (
                                treeNode(child, key, fullPath)
                            ))}
                            {!props?.loading && Object.keys(node).length === 0 &&
                                <div className="sa-empty-projectTree"><img src={emptyFolder} alt="img" /> <span className="fw-bold">Empty</span></div>}
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        );
    };

    const handleReload = () => {
        let load;
        props._renderFetchStorageFilesFolders("", load = true);
        setFileContextValue("");
    }

    return (
        <>
            <div className="position-relative tree-wrap ps-2" style={{ height: props?.height - 173 }}>
                {Object.entries(storageData).map(([name, node], index) => (
                    treeNode(node, name, "", index)
                ))}
                <OverlayTrigger placement="top"
                    overlay={<Tooltip id="tooltip">
                        <span className="d-inline-block font10">Reload</span>
                    </Tooltip>}>
                    <span className="sa-project-reload" onClick={() => handleReload()}><i className="fa-solid fa-rotate-right"></i></span>
                </OverlayTrigger>
            </div>
        </>
    )

}

export default TreeView;